export default __webpack_public_path__ + "static/media/default.0a63f821.jpg";